import {doc} from './docs.js';
import ZAttributes from "zobject/custom/ZAttributes.js";

doc(
    "attributes",
    {
        "operation":""
    },
    "Allows creating and controlling attributes for the containing subpatch dynamically",
    () => 0,
    {
        inlets: 0
    },
);
export const attributes = (object) => {
    let zattributes = new ZAttributes(object);
    object.needsLoad = true;
    return ([msg]) => {
        zattributes.loadBang();
        return [];
    };
};

